import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { callautopopulate } from "../../../services/callautopop";
import _ from "underscore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { dateConvert, formatDateObject } from "../../../utils/Helper";
import { ToastContext } from "../../../context/ToastContext";
import * as XLSX from 'xlsx';
import { useNavigate } from "react-router-dom";

export const useSurveyList = () => {

    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const [filterValues, setFilterValues] = useState({ status: "", types: [], users: [], date: [], is_change: false, search: "" });
    const [options, setOptions] = useState({ status: [], types: [], users: [], survey_templates: [] });
    const [rowData, setRowData] = useState({ filtered: [], all: [] });
    const [showCreateSurvey, setShowCreateSurvey] = useState({ visible: false, data: [], edit_survey_id: 0, edit_survey_name: "" });
    const [showShareSurvey, setShowShareSurvey] = useState(false);
    const menuRef = useRef(null);
    const iconRef = useRef(null);
    const tagRef = useRef(null);
    const navigate = useNavigate(null);
    const [menuItems, setMenuItems] = useState([]);
    const [loader, setLoader] = useState({ grid: false, revert: false, delete: false, duplicate: false, excel: false });
    const [scrollTop, setScrollTop] = useState(0);
    const [viewDialog, setViewDialog] = useState({ duplicate: false, revert: false, delete: false, preview: false, publish: false, excel: false, header: "", duplicate_survey_name: "", copy_opts: {}, username: "", password: "", showPassword: false });
    const columnDef = [
        {
            field: "srno",
            headerName: "Sr. No.",
            valueGetter: (params) => params.node.rowIndex + 1,
            flex: 0.5,
            cellStyle: { textAlign: "center", display: "flex", alignItems: "center" },
        },
        {
            field: "survey_name",
            headerName: "Survey Name",
            flex: 5,
            cellRenderer: (params) => {
                return (
                    <div className="w100 px-2 h-100">
                        <div className="d-flex gap-2 align-items-center fw-semibold h-50">
                            <div className="h-100 d-flex align-items-center" style={{ fontSize: "0.9rem" }}>{params?.value}</div>
                            <div className="d-flex align-items-center justify-content-center rounded-circle" style={{ backgroundColor: "#e1e6eacc", width: "25px", height: "25px" }} title="No. of questions">{params?.data?.question_count || 0}</div>
                        </div>
                        <div className="border px-2 d-flex align-items-center" style={{ height: "40%", width: "fit-content", borderRadius: "15px" }} title="Survey Type">{params?.data?.survey_type_name}</div>
                    </div>
                )
            }
        },
        {
            field: "survey_status",
            headerName: "Status",
            flex: 1,
            cellRenderer: (params) => {
                let statusStyle = { height: "20px", borderRadius: "15px", backgroundColor: "#e1e6eacc", color: "#1e262f" };
                if (params?.value === "published") {
                    statusStyle["color"] = "#ca8a04";
                    statusStyle["border"] = "1px solid #eab308";
                    statusStyle["backgroundColor"] = "transparent"
                } else if (params?.value === "active") {
                    statusStyle["backgroundColor"] = "#1e262f";
                    statusStyle["color"] = "white";
                }
                const status_name = _.findWhere(options?.status, { status_key: params?.value })?.status_name;
                return (
                    <div className="d-flex justify-content-center align-items-center h-100">
                        <div className="d-flex justify-content-center align-items-center px-2 fw-semibold" style={statusStyle}>{status_name || params?.value}</div>
                    </div>
                )
            }
        },
        {
            field: "total_user_response",
            headerName: "Responses",
            flex: 1,
            cellRenderer: (params) => {
                return (
                    <div
                        className="h-100 d-flex align-items-center c-pointer text-decoration-underline ps-2"
                        onClick={() => { navigate("/survey-response", { state: { surveyData: params?.data } }) }}

                    >
                        {params?.data?.total_user_response || 0} / {params?.data?.total_survey_response || 0}</div>
                )
            }
        },
        {
            field: "start_datetime",
            headerName: "Start / End Date",
            flex: 1.5,
            cellRenderer: (params) => {
                return (
                    <div className="ps-2">
                        <div style={{ height: "20px" }}>{params?.data?.start_datetime ? dateConvert(params?.data?.start_datetime, "date-time-months") : "N/A"}</div>
                        <div style={{ height: "20px" }}>{params?.data?.end_datetime ? dateConvert(params?.data?.end_datetime, "date-time-months") : "N/A"}</div>
                    </div>
                )
            }
        },
        {
            field: "publish_datetime",
            headerName: "Published At",
            flex: 1.5,
            cellRenderer: (params) => {
                return (
                    <div className="ps-2 d-flex align-items-center h-100">{params?.value ? dateConvert(params?.value, "date-time-months") : "N/A"}</div>
                )
            }
        },
        {
            field: "actions",
            headerName: "Actions",
            flex: 1,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div className="d-flex align-items-center h-100">
                        <div ref={iconRef} className="c-pointer w100" onClick={(e) => { handleGetMenu(e, params?.data) }}>
                            <FontAwesomeIcon icon="fa-solid fa-ellipsis" />
                        </div>
                    </div>
                )
            }
        },
    ]

    useEffect(() => {
        callautopopulate("survey_type", "users", "survey_status", "survey_templates", "survey_copy_option")?.then(res => {
            const status = _.sortBy(res?.survey_status, "status_name")
            setOptions((prev) => ({
                ...prev,
                status: [{ status_key: "", status_name: "All" }, ...status],
                types: _.sortBy(res?.survey_type, "survey_type_name"),
                users: _.sortBy(res?.users, "user_display_name"),
                survey_templates: _.sortBy(res?.survey_templates, "template_name"),
                survey_copy_option: res?.survey_copy_option
            }));
        })
        getSurveyInfoList();
    }, [])

    const getSurveyInfoList = async (key, newvalue) => {
        try {
            if ((!filterValues?.date?.[0] && filterValues?.date?.[1]) || (!filterValues?.date?.[1] && filterValues?.date?.[0])) {
                return;
            }
            const viewport = document.querySelector('.ag-body-viewport');
            if (viewport) { setScrollTop(viewport.scrollTop) };
            setLoader((prev) => ({ ...prev, grid: true }));
            const paylaod = {
                "survey_status": key === "status" ? newvalue : filterValues?.status || "",
                "survey_type_ids": key === "type" ? "" : _.pluck(filterValues?.types, "survey_type_id")?.toString() || "",
                "requested_user_codes": key === "user" ? "" : _.pluck(filterValues?.users, "user_code")?.toString() || "",
                "from_date": formatDateObject(filterValues?.date?.[0]) || "",
                "to_date": formatDateObject(filterValues?.date?.[1]) || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("GETSURVEYINFOLIST"), paylaod);
            if (res) {
                const data = res?.body?.data?.survey_list_details;
                setRowData((prev) => ({ ...prev, all: data }));
                if (filterValues?.search) {
                    onFilterTextBoxChanged(filterValues?.search, data);
                } else {
                    setRowData((prev) => ({ ...prev, filtered: data }));
                }
                setLoader((prev) => ({ ...prev, grid: false }));
                setFilterValues((prev) => ({ ...prev, is_change: false }));
                setTimeout(restoreScroll, 50);
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader((prev) => ({ ...prev, grid: false }));
        }
    }

    const getSurveyInfo = async (rowdata, key) => {
        try {
            setShowCreateSurvey((prev) => ({ ...prev, data: [], visible: false }));
            const res = await services.getInvokeRemote("POST", Urls("GETSURVEYINFO"), { survey_id: rowdata?.survey_id });
            if (res) {
                setShowCreateSurvey((prev) => ({ ...prev, data: res?.body?.data, visible: key === "edit" ? true : false }));
            }
        } catch (error) {
            console.error("Error: ", error);
        }
    }

    const handleGetMenu = (e, rowdata) => {
        let items = [
            {
                label: rowdata?.survey_status === "draft" ? 'Edit' : (rowdata?.survey_status === "closed" ? "View" : 'View / Edit'),
                icon: 'pi pi-pen-to-square',
                command: () => { getSurveyInfo(rowdata, "edit"); }
            },
            {
                label: 'Preview',
                icon: 'pi pi-eye',
                command: async () => { if (rowdata?.question_count > 0) { setViewDialog((prev) => ({ ...prev, preview: true, header: rowdata?.survey_name })); await getSurveyInfo(rowdata); } }
            },
            // {
            //     label: 'Analytics',
            //     icon: 'pi pi-chart-bar',
            //     command: () => { }
            // },
            {
                label: 'Share',
                icon: 'pi pi-share-alt',
                command: async () => { setShowShareSurvey(true); await getSurveyInfo(rowdata); }
            },
            {
                label: 'Duplicate',
                icon: 'pi pi-clone',
                command: () => { setViewDialog((prev) => ({ ...prev, duplicate: true, duplicate_survey_name: `Copy of ${rowdata?.survey_name}` })); }
            },
        ];
        if (rowdata?.survey_status === "draft") {
            items?.splice(2, 2, {
                label: 'Publish',
                icon: 'pi pi-send',
                command: () => { setViewDialog((prev) => ({ ...prev, publish: true, header: "Publish Survey?" })); }
            })
            items?.push({
                label: 'Delete',
                icon: 'pi pi-trash',
                command: () => { setViewDialog((prev) => ({ ...prev, delete: true, header: "Delete Draft Survey?" })); },
                template: (item) => {
                    return (
                        <div className='p-menuitem-content'>
                            <a className="p-menuitem-link">
                                <span className={`text-danger p-menuitem-icon ${item?.icon}`} />
                                <span className="p-menuitem-text text-danger">{item?.label}</span>
                            </a>
                        </div>
                    )
                }
            })
        } else if (rowdata?.survey_status === "published") {
            if (rowdata?.survey_status === "published") {
                items?.splice(items?.length - 1, 0, {
                    label: 'Revert Publish',
                    icon: 'pi pi-arrow-left',
                    command: () => { setViewDialog((prev) => ({ ...prev, revert: true, header: "Revert to Draft?" })); }
                })
            }
            // else {
            //     items?.splice(items?.length - 1, 0, {
            //         label: 'Stop Survey',
            //         icon: 'pi pi-stop-circle',
            //         command: () => { },
            //         template: (item) => {
            //             return (
            //                 <div className='p-menuitem-content'>
            //                     <a className="p-menuitem-link">
            //                         <span className={`text-danger p-menuitem-icon ${item?.icon}`} />
            //                         <span className="p-menuitem-text text-danger">{item?.label}</span>
            //                     </a>
            //                 </div>
            //             )
            //         }
            //     })
            // }
        }
        if (rowdata?.survey_status === "active") {
            items?.splice(items?.length, 0, {
                label: 'Download',
                icon: 'pi pi-download',
                command: () => { setViewDialog((prev) => ({ ...prev, excel: true, header: "Download Excel", surveyData: rowdata })); }
            })
        }
        else if (rowdata?.survey_status === "closed") {
            items = _.filter(items, item => item?.label !== 'Share');
        }
        setMenuItems(items);
        menuRef?.current?.show(e, iconRef?.current);
        setShowCreateSurvey((prev) => ({ ...prev, data: rowdata, edit_survey_id: rowdata?.survey_id, edit_survey_name: rowdata?.survey_name }))
    }

    const handleAction = async (key) => {
        try {
            let surveyCopy = [];
            if (key === "duplicate" && (viewDialog?.duplicate_survey_name?.toLowerCase()?.trim() === showCreateSurvey?.edit_survey_name?.toLowerCase()?.trim())) {
                showInfo("Info", "You cannot create copy with the same survey name");
                return;
            } else if (key === "duplicate") {
                const existing = _.filter(rowData?.all, item => item?.survey_name?.toLowerCase()?.trim() === viewDialog?.duplicate_survey_name?.toLowerCase()?.trim());
                if (!_.isEmpty(existing) && existing?.[0]?.survey_id !== (showCreateSurvey?.edit_survey_id || 0)) {
                    showInfo("Info", "This survey name already exists");
                    return;
                }

                Object.entries(viewDialog?.copy_opts)?.forEach(([key, value]) => {
                    if (value) {
                        surveyCopy.push(key);
                    }
                })
            } else if (key === "publish" && showCreateSurvey?.data?.question_count <= 0) {
                showInfo("Info", "Survey with 0 questions cannot be published");
                return;
            }
            setLoader((prev) => ({ ...prev, [key]: true }));
            const payload = {
                survey_id: showCreateSurvey?.edit_survey_id || 0,
                survey_name: key === "duplicate" ? viewDialog?.duplicate_survey_name : undefined,
                survey_copy_options: key === "duplicate" ? surveyCopy?.toString() : undefined
            }
            const res = await services.getInvokeRemote("POST", Urls(key === "revert" ? "SAVESURVEYINFOREVERT" : (key === "delete" ? "REMOVESURVEYINFO" : key === "duplicate" ? "SAVESURVEYINFOCOPY" : key === "publish" ? "SAVESURVEYPUBLISH" : "")), payload);
            if (res) {
                showSuccess("Success", res?.body?.message);
                setViewDialog((prev) => ({ ...prev, [key]: false, header: "", duplicate_survey_name: "" }));
                getSurveyInfoList();
                setShowCreateSurvey((prev) => ({ ...prev, edit_survey_id: 0, edit_survey_name: "" }));
                setLoader((prev) => ({ ...prev, [key]: false }));
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader((prev) => ({ ...prev, [key]: false }));
            showError("Error", error?.response?.data?.errorMessage)
        }
    }

    const onFilterTextBoxChanged = (e, rowdata) => {
        setFilterValues((prev) => ({ ...prev, search: e }))
        const val = e?.toLowerCase()?.trim();
        const allRows = rowdata ? [...rowdata] : [...rowData?.all] || [];
        if (!val) {
            setRowData((prev) => ({ ...prev, filtered: allRows }));
            return;
        }

        const isPhraseSearch = val?.includes(" ");
        let allFields = _.pluck(columnDef, "field");
        allFields?.push("survey_type_name");
        const filtered = allRows.filter((row) => {
            const text = allFields.map(field => row[field]).filter(Boolean).join(" ").toLowerCase();
            if (isPhraseSearch) {
                return text.includes(val);
            } else {
                return text.split(/\s+/).some((word) => word.includes(val));
            }
        });

        setRowData((prev) => ({ ...prev, filtered }));
    };

    const restoreScroll = () => {
        const interval = setInterval(() => {
            const viewport = document.querySelector('.ag-body-viewport');
            if (viewport) {
                viewport.scrollTop = scrollTop;
                clearInterval(interval);
            }
        }, 30);
    };

    const attachScrollListener = () => {
        const viewport = document.querySelector('.ag-body-viewport');
        if (!viewport) return;

        viewport.addEventListener('scroll', () => {
            setScrollTop(viewport.scrollTop);
        });
    };

    const handleExportSurveyData = async () => {
        try {
            setLoader((prev) => ({ ...prev, excel: true }));
            const payload = {
                "survey_id": viewDialog?.surveyData?.survey_id,
                "user_name": viewDialog?.username,
                "token": viewDialog?.password
            };
            const res = await services.getInvokeRemote("POST", Urls("GETSURVEYEXCELEXPORTDATA"), payload);
            if (!res?.body?.error_status) {
                const rawData = res?.body?.data || [];
                const workbook = XLSX.utils.book_new();
                const summaryMap = {};
                const categories = [...new Set(rawData.map(item => item.question_category_name || "General"))];
                categories.forEach(category => {
                    const categoryData = rawData.filter(item => (item.question_category_name || "General") === category);
                    const groupedData = categoryData.reduce((acc, curr) => {
                        const key = `${curr?.evaluator_user_code}_${curr?.subject_user_name}`;
                        const start = new Date(curr?.start_datetime);
                        const end = new Date(curr?.end_datetime);
                        const diffMs = end - start;
                        const diffMin = diffMs > 0 ? Math.floor(diffMs / 1000 / 60) : 0;
                        if (!acc[key]) {
                            acc[key] = {
                                "Target User": curr?.subject_user_name,
                                "Evaluator": curr?.evaluator_user_name,
                                "Start Time": dateConvert(curr?.start_datetime, "hour-min"),
                                "Close Time": dateConvert(curr?.end_datetime, "hour-min"),
                                "Time Spent Min": diffMin,
                                "ratingValues": [],
                                "questions": {}
                            };
                            const targetUser = curr?.subject_user_name || "Unknown";
                            if (!summaryMap[targetUser]) {
                                summaryMap[targetUser] = {
                                    "Target User": targetUser,
                                    "totalRatingSum": 0,
                                    "evaluationCount": 0
                                };
                            }
                            summaryMap[targetUser].evaluationCount += 1;
                        }
                        const qKey = curr?.question_title || `Question ID: ${curr?.question_id}`;
                        if (curr?.question_type_name === "rating") {
                            const val = Number(curr?.answer_data || 0);
                            acc[key].questions[qKey] = val;
                            acc[key].ratingValues.push(val);
                            const targetUser = curr?.subject_user_name || "Unknown";
                            if (!summaryMap[targetUser][category]) summaryMap[targetUser][category] = 0;
                            summaryMap[targetUser][category] += val;
                            summaryMap[targetUser].totalRatingSum += val;
                        } else {
                            acc[key].questions[qKey] = curr?.answer_data || "N/A";
                        }
                        return acc;
                    }, {});
                    const sheetRows = Object.values(groupedData).map(row => {
                        const ratingTotal = row.ratingValues.reduce((a, b) => a + b, 0);
                        return {
                            "Target User": row["Target User"],
                            "Evaluator": row["Evaluator"],
                            "Start Time": row["Start Time"],
                            "Close Time": row["Close Time"],
                            "Time Spent Min": row["Time Spent Min"],
                            ...row.questions,
                            "Rating Total": ratingTotal,
                        };
                    });
                    sheetRows.sort((a, b) => (a["Target User"] || "").toLowerCase().localeCompare((b["Target User"] || "").toLowerCase()));

                    if (sheetRows.length > 0) {
                        const safeName = category?.replace(/[\\/??*\[\]:<>|]/g, "_")?.replace(/^'|'$/g, "")?.trim()?.substring(0, 31) || "Sheet1";
                        const worksheet = XLSX.utils.json_to_sheet(sheetRows);
                        const objectKeys = Object.keys(sheetRows[0]);
                        const colWidths = objectKeys.map(key => ({ wch: Math.min(key.toString().length + 10, 60) }));
                        worksheet['!cols'] = colWidths;
                        XLSX.utils.book_append_sheet(workbook, worksheet, safeName);
                    }
                });
                const summaryRows = Object.values(summaryMap).map(userRow => {
                    const { totalRatingSum, evaluationCount, ...rest } = userRow;
                    const finalAverage = evaluationCount > 0 ? (totalRatingSum / evaluationCount).toFixed(2) : 0;
                    const cleanedRow = { "Target User": rest["Target User"] };
                    categories.forEach(cat => {
                        cleanedRow[cat] = rest[cat] || 0;
                    });
                    cleanedRow["Total Rating Score"] = totalRatingSum;
                    cleanedRow["Final Average Rating"] = Number(finalAverage);

                    return cleanedRow;
                });

                summaryRows.sort((a, b) => a["Target User"].localeCompare(b["Target User"]));

                if (summaryRows.length > 0) {
                    const summaryWorksheet = XLSX.utils.json_to_sheet(summaryRows);
                    summaryWorksheet['!cols'] = Object.keys(summaryRows[0]).map(k => ({ wch: 20 }));
                    XLSX.utils.book_append_sheet(workbook, summaryWorksheet, "Final Report");
                }

                XLSX.writeFile(workbook, `Survey_Export_${viewDialog?.surveyData?.survey_name}.xlsx`);
                showSuccess("Success", res.body.message);
                setViewDialog((prev) => ({ ...prev, excel: false, loader: false, username: "", password: "", surveyData: "", showPassword: false }));
                setLoader((prev) => ({ ...prev, excel: false }));
            } else {
                showError("Error", res.body.message);
            }
        } catch (error) {
            showError("Error", "Something want wrong.");
            console.error("error:::::", error);
            setLoader((prev) => ({ ...prev, excel: false }));
        }
    };

    return useMemo(() => ({
        tagRef, filterValues, setFilterValues, getSurveyInfoList, options, showCreateSurvey, setShowCreateSurvey, columnDef, rowData, menuRef, menuItems, viewDialog, setViewDialog, handleAction, loader, onFilterTextBoxChanged, attachScrollListener, showShareSurvey, setShowShareSurvey, handleExportSurveyData, getSurveyInfo
    }), [tagRef, filterValues, setFilterValues, getSurveyInfoList, options, showCreateSurvey, setShowCreateSurvey, columnDef, rowData, menuRef, menuItems, viewDialog, setViewDialog, handleAction, loader, onFilterTextBoxChanged, attachScrollListener, showShareSurvey, setShowShareSurvey, handleExportSurveyData, getSurveyInfo])
}


